// @ts-nocheck

import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaCirclePlus, FaCircleMinus } from "react-icons/fa6";
import { createTestimonial } from "../../../features/testimonials";

const AddTestimonial = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    customer_name: "", 
    customer_designation: "", 
    feedback: "", 
    customer_image: null, 
  });

  const [imagePreview, setImagePreview] = useState(null); 

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value, 
    }));
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        customer_image: e.target.files[0],
      }));
      setImagePreview(URL.createObjectURL(e.target.files[0])); // For image preview
    }
  };

  const handleSubmit = () => {
    // Dispatch createTestimonial with formData
    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(createTestimonial(formDataFinal))
      .then((res) => {
        toast.success("Testimonial added successfully!");
        navigate("/testimonials"); 
      })
      .catch((err) => {
        console.log(err, "error");
        toast.error("An error occurred while adding the testimonial.");
      });
  };

  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
      mt={15}
    >
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Add Testimonial
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Customer Name
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="customer_name"
              placeholder="Enter the customer's name"
              value={formData.customer_name}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Customer Designation
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="customer_designation"
              placeholder="Enter the customer's designation"
              value={formData.customer_designation}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Feedback
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="feedback"
              placeholder="Enter the customer's feedback"
              value={formData.feedback}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Customer Image
              </SoftTypography>
            </SoftBox>
            <input
              type="file"
              accept="image/*"
              name="customer_image"
              onChange={handleImageChange}
              style={{ width: "100%" }}
            />
            {imagePreview && (
              <img src={imagePreview} alt="Preview" style={{ width: "150px", height: "150px", marginTop: "20px" }} />
            )}
          </SoftBox>

          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddTestimonial;
